//node modules
import {useNavigate} from "react-router-dom";

//callable functions
import {fb_signOut} from "../../../../global/callback functions/autentication/fb_signOut";

//components
import {Button, Col, Row} from "reactstrap";
import TriggerCheckCampaignEnd from "./TriggerCheckCampaignEnd";

export default function SideControlActions() {
  const navigate = useNavigate();
  return (
    <Row className={"sideControl_actions"}>
      <Col sm={12}>
        <Button
          color={'danger'}
          onClick={() => {
            fb_signOut();
            navigate("/login");
          }}>
          Logg ut
        </Button>
      </Col>
      <Col sm={12} style={{marginTop: "4rem"}}>
        <div className={"sideControl-heading"}>
          <p className={"h5"}>Administrator Kontroll</p>
        </div>
        <div>
          <TriggerCheckCampaignEnd/>
        </div>
      </Col>
    </Row>
  )
}
